/* ==========================================================================
   Stick'it — passerelle panier maison -> panier Shopify.
   Le site garde son panier (localStorage « stickit_cart_v1 », tiroir, prix affichés).
   Au clic sur « Commander » : chaque article est converti en variante Shopify
   (taille / couleur / fond… reconnues par leurs valeurs), le reste des choix part en
   propriétés de commande (pseudo, typo, texte, côté…), l'aperçu et le fichier client
   sont joints en fichiers, puis redirection vers /checkout.
   Fichiers client (page « Ton custom ») : gardés dans IndexedDB (window.SKFiles) pour
   survivre à un changement de page.
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'stickit_cart_v1';

  /* ---- fichiers client (IndexedDB) ---- */
  function idb() {
    return new Promise(function (ok, ko) {
      if (!window.indexedDB) return ko(new Error('no idb'));
      var r = indexedDB.open('stickit-files', 1);
      r.onupgradeneeded = function () { r.result.createObjectStore('f'); };
      r.onsuccess = function () { ok(r.result); };
      r.onerror = function () { ko(r.error); };
    });
  }
  function tx(mode, fn) {
    return idb().then(function (db) {
      return new Promise(function (ok, ko) {
        var t = db.transaction('f', mode), st = t.objectStore('f'), out = fn(st);
        t.oncomplete = function () { ok(out && out.result); };
        t.onerror = function () { ko(t.error); };
      });
    });
  }
  // Safari iOS : un Blob/File relu depuis IndexedDB peut être illisible à l'envoi (« WebKitBlobResource error »),
  // ce qui faisait échouer « Commander » sur téléphone. On garde donc le fichier en mémoire pour la page en cours,
  // et en IndexedDB sous forme d'octets bruts { name, type, data } recomposés en Blob à la lecture.
  var mem = {};
  function readBuf(blob) {
    if (blob.arrayBuffer) return blob.arrayBuffer();
    return new Promise(function (ok, ko) {
      var fr = new FileReader();
      fr.onload = function () { ok(fr.result); };
      fr.onerror = function () { ko(fr.error); };
      fr.readAsArrayBuffer(blob);
    });
  }
  function rebuild(v) {
    if (!v) return null;
    if (v.data) { var b = new Blob([v.data], { type: v.type || 'application/octet-stream' }); b.name = v.name || 'fichier'; return b; }
    return v;                                          // ancien format (Blob stocké tel quel)
  }
  window.SKFiles = {
    put: function (id, blob) {
      mem[id] = blob;
      return readBuf(blob).then(function (buf) {
        return tx('readwrite', function (s) { s.put({ name: blob.name || 'fichier', type: blob.type, data: buf }, id); });
      }).catch(function () {});
    },
    get: function (id) {
      if (mem[id]) return Promise.resolve(mem[id]);
      return window.SKFiles.reload(id);
    },
    // relit la copie en octets d'IndexedDB (sans passer par la mémoire)
    reload: function (id) {
      return tx('readonly', function (s) { return s.get(id); }).then(rebuild).catch(function () { return null; });
    }
  };

  /* ---- correspondance article -> variante ---- */
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, '').replace(/reflechissante/g, 'reflechissant');
  }
  function parts(variant) {
    return String(variant || '').split(' · ').map(function (p) {
      var i = p.indexOf(' : ');
      return i < 0 ? null : { k: p.slice(0, i).trim(), v: p.slice(i + 3).trim() };
    }).filter(Boolean);
  }
  // /products/x.js ne renvoie que 250 variantes : au-delà (Instagram stickers en a 253), on lit les suivantes
  // par l'API Storefront de la boutique (accès public, sans clé), page par page. Si elle échoue, on garde les 250.
  var SF_API = '/api/2025-07/graphql.json';
  var SF_Q = 'query($h:String!,$a:String){product(handle:$h){variants(first:250,after:$a){pageInfo{hasNextPage endCursor} nodes{id selectedOptions{value}}}}}';
  function withExtra(p) {
    if (!p || !p.variants || p.variants.length < 250) return p;
    var known = {};
    p.variants.forEach(function (v) { known[v.id] = 1; });
    function page(after) {
      return j(SF_API, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ query: SF_Q, variables: { h: p.handle, a: after || null } }) }).then(function (r) {
        var vs = r && r.data && r.data.product && r.data.product.variants;
        if (!vs) return p;
        vs.nodes.forEach(function (n) {
          var id = +String(n.id).split('/').pop();
          if (!id || known[id]) return;
          known[id] = 1;
          var v = { id: id };
          n.selectedOptions.forEach(function (o, i) { v['option' + (i + 1)] = o.value; });
          p.variants.push(v);
        });
        return vs.pageInfo.hasNextPage ? page(vs.pageInfo.endCursor) : p;
      });
    }
    return page().catch(function () { return p; });
  }
  function resolve(item) {
    var ps = parts(item.variant), handle = item.id;
    if (/^custom-/.test(item.id)) {
      handle = 'sticker-personnalise';
      ps.forEach(function (p) { if (p.k === 'Couleur') p.v = p.v.replace(/\s*\(spéciale[^)]*\)\s*$/, ''); });
    } else if (/^casque-custom-/.test(item.id)) {
      handle = 'sticker-casque-a-ton-nom';
      // nom « Casque personnalisé — style Death Metal » ; à défaut, l'id de police (casque-custom-necrosarqe)
      var STY = { novocane: 'Novocare', necrosarqe: 'Death Metal', trashcrush: 'Trash Crush' };
      var style = STY[item.id.replace(/^casque-custom-/, '')] ||
        String(item.name || '').split('— ').pop().replace(/^style\s+/i, '');
      var col = (ps.filter(function (p) { return p.k === 'Couleur'; })[0] || {}).v || '';
      // couleurs spéciales : +3 CHF (variantes à 38) ; les autres spéciales passent par la finition « Spéciale »
      var fin = /holographique/i.test(col) ? 'Holographique' : (/r[ée]fl[ée]chissant/i.test(col) ? 'Réfléchissant' :
        (/noir mat|gris m[ée]tallis[ée]|gris anthracite|dor[ée]/i.test(col) ? 'Spéciale' : 'Standard'));
      ps.unshift({ k: 'Style', v: style }, { k: 'Finition', v: fin });
    }
    return { handle: handle, parts: ps };
  }
  function optionsOf(p) {
    return (p.options || []).map(function (o, i) {
      return typeof o === 'string' ? { name: o, values: uniq(p.variants.map(function (v) { return v['option' + (i + 1)]; })) } : o;
    });
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function match(product, ps) {
    var used = {}, chosen = [];
    optionsOf(product).forEach(function (o, oi) {
      var vals = o.values.map(norm), fond = /fond/i.test(o.name), best = -1;
      ps.forEach(function (p, i) {
        if (used[i] || vals.indexOf(norm(p.v)) < 0) return;
        var good = fond === /fond/i.test(p.k);
        if (best < 0 || (good && !(fond === /fond/i.test(ps[best].k)))) best = i;
      });
      if (best >= 0) { used[best] = true; chosen[oi] = norm(ps[best].v); }
    });
    var variant = product.variants.filter(function (v) {
      return chosen.every(function (c, oi) { return c == null || norm(v['option' + (oi + 1)]) === c; }) &&
        optionsOf(product).every(function (o, oi) { return chosen[oi] != null; });
    })[0];
    return { variant: variant, extra: ps.filter(function (p, i) { return !used[i]; }) };
  }
  function dataUrlBlob(u) {
    var m = /^data:([^;]+);base64,(.*)$/.exec(u || ''); if (!m) return null;
    var b = atob(m[2]), a = new Uint8Array(b.length);
    for (var i = 0; i < b.length; i++) a[i] = b.charCodeAt(i);
    return new Blob([a], { type: m[1] });
  }
  function j(url, opt) {
    return fetch(url, opt).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(url + ' : ' + r.status + ' ' + t.slice(0, 160)); });
      return r.json();
    });
  }

  /* ---- envoi ---- */
  function checkout(btn) {
    var items = [];
    try { items = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    if (!items.length) return;
    var label = btn.querySelector('span') || btn, txt = label.textContent;
    label.textContent = 'Préparation…'; btn.setAttribute('aria-busy', 'true');
    var cache = {};
    var chain = j('/cart/clear.js', { method: 'POST' });
    items.forEach(function (item) {
      chain = chain.then(function () {
        var r = resolve(item);
        cache[r.handle] = cache[r.handle] || j('/products/' + r.handle + '.js').then(withExtra);
        return cache[r.handle].then(function (product) {
          var m = match(product, r.parts);
          if (!m.variant) throw new Error('Variante introuvable pour « ' + item.name + ' » (' + item.variant + ')');
          var fd = new FormData();
          fd.append('id', m.variant.id);
          fd.append('quantity', item.qty || 1);
          m.extra.forEach(function (p) { if (p.v && p.v !== 'aucun') fd.append('properties[' + p.k + ']', p.v); });
          var design = dataUrlBlob(item.design);
          if (design) fd.append('properties[Aperçu]', design, 'apercu-' + r.handle + (design.type === 'image/png' ? '.png' : '.jpg'));
          var file = /^custom-/.test(item.id) ? window.SKFiles.get(item.id) : Promise.resolve(null);
          var send = function (f) {
            var body = new FormData();
            fd.forEach(function (v, k) { if (v instanceof Blob) body.append(k, v, v.name || 'fichier'); else body.append(k, v); });
            if (f) body.append('properties[Fichier]', f, f.name || 'fichier');
            return j('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } });
          };
          return file.then(function (f) {
            // fichier illisible au premier envoi (Safari) : nouvel essai avec la copie en octets d'IndexedDB
            return send(f).catch(function (e) {
              if (!f) throw e;
              return window.SKFiles.reload(item.id).then(function (g) { if (!g) throw e; return send(g); });
            });
          });
        });
      });
    });
    chain.then(function () { location.href = '/checkout'; }).catch(function (e) {
      label.textContent = txt; btn.removeAttribute('aria-busy');
      var foot = btn.parentNode, msg = foot.querySelector('.sk-co-err');
      if (!msg) { msg = document.createElement('p'); msg.className = 'sk-co-err'; msg.style.cssText = 'color:#ff5a7a;font-size:13px;margin-top:10px'; foot.appendChild(msg); }
      msg.textContent = 'Oups, quelque chose ne s\x27est pas bien passé. Réessaie dans un instant ou écris-nous.'; // jamais de détail technique pour le client (il reste dans la console)
      if (window.console) console.error(e);
    });
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.drawer-f .btn');
    if (!btn) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (btn.getAttribute('aria-busy') !== 'true') checkout(btn);
  }, true);
  window.StickitShopify = { resolve: resolve, match: match, norm: norm };
})();
